<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import ImportTemplate from "@/views/components/common/form/workTypeTemplate.vue";
import config from "../../../../config";
let customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,
  components: {
    ImportTemplate,
  },
  data() {
    return {
      table: {
        mname: "workType",
        key: "id",
        url: {
          del: "/admin/system/workType",
          list: "/admin/system/workType/list",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "system/worktype/add",
        },
        {
          label: "导入分类",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "",
          type: "info",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          auth: "system/workType/download",
          type: "info",
        },
        {
          label: "导出分类",
          icon: "md-download",
          type: "info",
          onClick: this.exportData.bind(this, "工单分类列表", 5),
          auth: "system/workType/exportData",
        },
      ],
      menus: [],
      filters: [
        {
          label: "类型名称",
          KeyEnter: this.search,
          name: "name",
          value: "",
          type: "input",
        },
        // { label: '标题', name: 'user_nick', value: '', type: 'input', },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "类型名称",
          key: "name",
          align: "left",
        },
        // {
        //   title: "品牌",
        //   key: "brand",
        //   width: 200,
        //   align: "left",
        //   tooltip: "true",
        // }, {
        //   title: "厂家",
        //   key: "manufacturer",
        //   width: 200,
        //   align: "left",
        //   tooltip: "true",
        // }, {
        //   title: "供应商",
        //   key: "service",
        //   width: 200,
        //   align: "left",
        //   tooltip: "true",
        // },

        {
          title: "负责人",
          align: "left",
          key: "userNames",
        },

        {
          title: "备注",
          key: "remark",
          align: "left",
        },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            // console.log(text);
            let result = "";
            var n = 10; //指定第n位换行
            for (var i = 0, len = text.length; i < len; i++) {
              result += text[i];
              if ((i + 1) % n == 0) result += "\r\n";
            }
            return <span>{result}</span>;
          },
          /*  render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          }, */
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
          auth: {
            edit: "system/worktype/edit",
            del: "system/worktype/delete",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    toAdd() {
      console.log("111111");

      $utils.url.push({ name: "worktype_add", query: { action: "add" } });
    },
    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/workType/template/download`;
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "worktype_edit",
        query: { action: "edit", kv: kv },
      });
    },
  },
};
</script>
<style scoped></style>
